import { useQuestionPrefillByCar } from '@flows/src/api/postQuestionPrefillByCar';
import useFlowsAnswer from '@flows/src/hooks/useFlowsAnswer';
import useFlowsHelper from '@flows/src/hooks/useFlowsHelper';
import { useFlowsRouteParams } from '@flows/src/hooks/useFlowsRouteParams';
import VehicleResponseHeaderContainer from '@toolkit/src/components/VehicleResponseHeaderContainer';
import { VStack } from '@wegroup/design-system';
import React, { useState } from 'react';
import { Car } from '../../../../../../../types/SMT';
import { CarResponseData } from '../../../../../../../types/VehicleResponse';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import { handleResponseLanguage } from '../../../../../../../i18n';
import FlowsBoxQuestionDescription from '../../../ui/advisory-flow/components/FlowsQuestionDescription';
import FlowsQuestionText from '../../../ui/advisory-flow/components/FlowsQuestionText';
import NumberPlateInput from './NumberPlateInput';

interface Props {
  question: FlowsQuestion;
}

const AdvisoryNumberPlateInputComponent: React.FC<Props> = ({ question }) => {
  const { sessionId } = useFlowsRouteParams();
  const { mutateAsync } = useQuestionPrefillByCar({});
  const { fillAnswers } = useFlowsAnswer();
  const { getGroupByQuestionId } = useFlowsHelper();
  const [carData, setCarData] = useState<CarResponseData>();
  const {
    field: { value, onBlur },
  } = useFlowInputComponent({ question });

  const handleVehicleFound = async (
    vehicle: Car,
    numberPlate: string,
    data: CarResponseData,
  ) => {
    const _data = await mutateAsync({
      sessionId: sessionId,
      payload: {
        car: vehicle,
        question_id: question.id,
        index: question.index,
      },
    });
    if (_data?.questions.length > 0) {
      const newAnswers = _data.questions.map((question) => ({
        ...question,
        groupId: getGroupByQuestionId(question.id)?.id,
        prefilled: true,
      }));
      fillAnswers(newAnswers);
    }
    setCarData(data);
    onBlur({ name: question.id, value: numberPlate.toUpperCase() });
  };

  return (
    <VStack align="stretch">
      <FlowsQuestionText question={question} />
      <FlowsBoxQuestionDescription question={question} />
      <NumberPlateInput
        name={question.id}
        value={value}
        onChange={handleVehicleFound}
        isDisabled={question.rules.is_disabled}
        regex={question.rules.regex?.js}
        regexErrorMessage={
          handleResponseLanguage(question.error_messages?.regex) || undefined
        }
      />
      {carData && (
        <VehicleResponseHeaderContainer isVin={false} data={carData} />
      )}
    </VStack>
  );
};

export default AdvisoryNumberPlateInputComponent;
